import React from "react"
import { graphql, StaticQuery } from "gatsby"

import LayoutBar from "../components/LayoutBar"
import Leader from "../components/Leader"
import Layout from "../components/Layout"
import Post from "../components/Post"
import SEO from "../components/SEO"

const IndexPage = () => {

    return (
        <Layout pageTitle="Welcome">
            <SEO title="Welcome" />
            <StaticQuery
                query={indexQuery}
                render={data => {
                return (

                    <div>
                        <Leader page="home"/>
                        <LayoutBar page="home"/>
                        <div className="grid grid-cols-12 gap-8">
                            {data.allMarkdownRemark.edges.map(({ node },i) => (
                                <div key={node.id} className={
                                    i===1 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===2 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===5 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===6 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===9 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===10 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===13 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===14 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===17 ? 'lg:col-span-5 sm:col-span-6 col-span-12' :
                                    i===18 ? 'lg:col-span-5 sm:col-span-6 col-span-12' : 'lg:col-span-7 sm:col-span-6 col-span-12'}>
                                    <Post
                                        key={node.id}
                                        title={node.frontmatter.title}
                                        author={node.frontmatter.author}
                                        github={node.frontmatter.github}
                                        web={node.frontmatter.web}
                                        slug={node.fields.slug}
                                        date={node.frontmatter.date}
                                        body={node.excerpt}
                                        fluid={node.frontmatter.image.childImageSharp.fluid}
                                        order={node.frontmatter.order}
                                        tags={node.frontmatter.tags}
                                        time={node.timeToRead}
                                        count={i}
                                    />
                                </div>
                            )
                            )}
                        </div>
                    </div>
                )
            }}
        />
        </Layout>
    )
}

const indexQuery = graphql `
    query MyQuery {
        allMarkdownRemark(
            sort:{fields: [frontmatter___order], order: DESC},
            filter:{frontmatter:{tags:{ne:"Blog"}}}
            )
        {
            totalCount
            edges {
                node {
                    id
                    timeToRead
                    frontmatter {
                        title
                        tags
                        author
                        github
                        web
                        order
                        date(formatString: "MMM do YYYY")
                        image {
                            childImageSharp {
                                fluid(grayscale: false, maxHeight: 260, webpQuality: 80, toFormat: WEBP) {
                                    ...GatsbyImageSharpFluid
                                    ...GatsbyImageSharpFluidLimitPresentationSize
                                }
                            }
                        }
                    }
                    fields{
                        slug
                    }
                    excerpt
                }
            }
        }
    }
`

export default IndexPage